<template>
  <div>
    <a-modal
      v-show="!ishand"
      id="warp_sim12"
      width="40rem"
      v-model="visible"
      on-ok="handleOk1"
      v-dragModal
      @cancel="handleCancel(0)"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
      :dialog-style="{top: 22 +'%'}"
    >
      <div class="mark-file">
        <div
          style="
            background-color: #0c8b97;
            border-radius: 10px 10px 0 0;
            color: #fff;
            width: 38rem;
            margin: 1rem 1rem 0 1rem;
            text-align: center;
          "
        >
          IOQ簽署審批
        </div>
      </div>
      <div solt="title" style="position: relative">
        <!-- <div style="position: absolute;top: 0;left: 0;background-color: red;">標題</div> -->
      </div>
      <div class="content" style="font-size: 16px;">
        <div style="padding-top: 1rem;">
            <div style="border: 1px solid #e5e5e5;">
                <div class="content-top1" style="background:#fafafa;">
                <span style="flex: 1;">證券帳號 <span style="margin-left: 10%;">{{dataAll.username}}</span></span>
                <span style="flex: 1;margin-left: 50px;">中文名稱 <span style="margin-left: 10%;">{{dataAll.customer_name}}</span></span>
                </div>
                <div class="content-top1" style="height:100%;">
                  <span style="flex: 1;display: flex;">
                    <span>電郵地址</span>
                    <span class="emailCla" :title="dataAll.email" :style="emailData.length>1 ? 'line-height: 30px;white-space: pre-wrap;':'white-space: nowrap;'">{{dataAll.email}}</span>
                  </span>
                  <!-- <span style="flex: 1;">電郵地址 <span style="display: inline-block;width: 206px;height: 100%;overflow: hidden;float: right;position: relative;right: 1%;text-overflow: ellipsis;white-space: nowrap;" :title="dataAll.email">{{dataAll.email}}</span></span> -->
                  <span style="flex: 1;margin-left: 50px;">電話號碼 <span style="margin-left: 10%;">{{dataAll.phone_number}}</span></span>
                </div>
                <!-- <div class="content-top1" style="background:#fafafa;" >
                  <span style="flex: 1;">登錄平台 <span style="margin-left: 10%;">{{dataAll.login_type}}</span></span>
                  <span style="flex: 1;margin-left: 50px;">提交時間 <span style="margin-left: 10%;">{{dataAll.submit_time}}</span></span>
                </div> -->
                <div class="content-top1" style="background:#fafafa;" >
                  <span style="flex: 1;">登錄平台 
                    <span style="margin-left: 10%;" class="denglu">
                        <a-select
                          v-model="dataAll.login_type"
                          placeholder="請選擇登錄平台"
                        >
                          <a-select-option
                            v-for="item in fileArr1"
                            :key="item.value"
                            :value="item.label"
                          >
                            {{ item.label }}
                            </a-select-option
                          >
                        </a-select>
                    </span>
                  </span>
                  <span style="flex: 1;margin-left: 50px;">提交時間 
                    <span style="margin-left: 10%;">
                      <a-date-picker v-model='dataAll.submit_time' :disabled="items.questionnaire_sign_status == '已過期'" allowClear @change="onChange(1)" :disabledDate="disabledDate" placeholder='請選擇提交時間' format="YYYY/MM/DD" style='width: 9rem;'/>
                    </span>
                  </span>
                </div>
                <div class="content-top1" style="height:100%;">
                  <div style="flex: 1;display: flex;align-items: center;">
                    <span style="flex-shrink: 0;">投資取向評級</span>
                    <a-select v-model="dataAll.orientation_type" placeholder="請選擇投資取向評級" style="margin-left: 0.5%;width: 9rem;">
                      <a-select-option :value="1">保守型</a-select-option>
                      <a-select-option :value="2">穩健型</a-select-option>
                      <a-select-option :value="3">均衡型</a-select-option>
                      <a-select-option :value="4">增長型</a-select-option>
                      <a-select-option :value="5">進取型</a-select-option>
                    </a-select>
                  </div>
                  <span style="flex: 1;margin-left: 50px;" v-if="items.questionnaire_sign_status == '已過期'">更新時間 
                    <span style="margin-left: 10%;">
                      <a-date-picker :class="{red_cla : redFlag}" v-model='dataAll.updata_time' allowClear @change="onChange(2)" :disabledDate="disabledDate" placeholder='請選擇更新時間' format="YYYY/MM/DD" style='width: 9rem;'/>
                    </span>
                  </span>
                </div>
            </div>
        </div>
        <div style="margin-top: 15px;" v-if="userfileAuditAdmin">
            <a-textarea v-model="value2" :rows="4"  placeholder="請輸入備註信息" allow-clear />
        </div>
        <div style="text-align: center;margin-top: 15px;" v-if="userfileAuditAdmin">
            <button class="btnOn" @click="btnOnClick(2)" v-if="wBen == 1 && file_type == 1">重新簽署</button>
            <button class="btnOK" @click="btnOnClick(1)">簽署成功</button>
        </div>
      </div>

      <div style="width: 100%; height: 1px"></div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment';
import App from "@/assets/app.js";
export default {
  props: ["items","wBen","file_type"],
  data() {
    return {

      redFlag: false,
      ishand: false,
      visible: true,
      dataAll:{
        updata_time:'',
      },
      value2:'',
      userfileAuditAdmin: this.$store.state.rolesdata.indexOf("userfileAuditAdmin") >= 0,
      filetype:'',
      fileArr1:[
        {
          value: "1",
          label: "iPhone",
        },
        {
          value: "2",
          label: "iPad",
        },
        {
          value: "3",
          label: "Android",
        },
        {
          value: "4",
          label: "Website",
        },
        {
          value: "5",
          label: "Email",
        },
        {
          value: "6",
          label: "Telephone",
        },
        {
          value: "7",
          label: "Post",
        },
      ],
      begindate:'',
      dataAll:'',
      emailData:[],
    };
  },
  mounted() {
    this.echoData()
    console.log(this.items);
   
  },

  methods: {
    disabledDate(current) {
      const time = moment().endOf('day')
      return current && current > time
      // return current && current > moment().endOf("day");
    },
    handleCancel(ev) {
      this.$emit("child", 0);
    },
    btnOnClick(val){
      if (val == 2) {
        if (this.value2 == '') {
          App.oTool.warningT('請輸入備註信息');
        }else{
          console.log('重新簽署');
          this.newUserFileAudit(val);
          this.$emit("child", 0);
        }
      }else if(val == 1){
        if (this.items.questionnaire_sign_status == '已過期') {
          if (!this.dataAll.updata_time) {
            this.redFlag = true
            return
          }
        }
        if (this.value2 == '') {
          this.value2 = "IOQ審批通過";
          this.newUserFileAudit(val);
          this.$emit("child", 0);
        }else{
          console.log('簽署成功');
          this.newUserFileAudit(val);
          this.$emit("child", 0);
        }
      }
      

     
    },
    newUserFileAudit(val) {
      //  var missionid;
      // if (this.file_type == 1) {
      //   missionid = this.items.w8ben_missionid
      // }else if (this.file_type == 2) {
      //   missionid = this.items.otc_missionid
      // }
      // console.log(val,this.value2,missionid);
      var submit_time = ''
      if (this.items.questionnaire_sign_status == '已過期') {
        submit_time = this.dataAll.updata_time
      }else{
        submit_time = this.dataAll.submit_time

      }
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/newUserFileAudit",
        url: this.$api.questionnaireAudit,
        data: {
          username:this.items.username,
          status:val,
          remark:this.value2,
          login_type:this.dataAll.login_type,
          submit_time:submit_time,
          orientation_type:this.dataAll.orientation_type,
          // missionid:missionid
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          App.oTool.successT('操作成功');
          // this.$router.go(0)
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },
    notSigned(){
      if (this.userfileAuditAdmin) {
        this.$ajax({
          method: "post",
          // url: "http://202.130.113.149:3785/admin/newFileInputHandle",
          url: this.$api.newFileInputHandle,
          data: {
            username:this.items.username,
            filetype:this.file_type , //1 w-8ben  2 otc 3 hkidr
            submittime:this.begindate ,
            remark:this.value2,
            way:this.filetype
          },
        }).then((res) => {
          if (res.data.qmiscode == 1000) {
            App.oTool.successT('操作成功');
            this.$emit("child", 0);
          } else {
            App.oTool.warningT(res.data.qmismsg);
          }
        });
      }else{
        App.oTool.warningT('暫無權限');
      }
    },
    onChange(val) {
      this.redFlag = false
      if (val == 1) {
        this.dataAll.submit_time = this.dataAll.submit_time ? App.oDate.secsTime3(this.dataAll.submit_time._d) : ''
      }else{
        this.dataAll.updata_time = this.dataAll.updata_time ? App.oDate.secsTime3(this.dataAll.updata_time._d) : ''
      }
      console.log(this.dataAll.submit_time);
    },

    echoData(){
      // var missionid;
      // if (this.file_type == 1) {
      //   missionid = this.items.w8ben_missionid
      // }else if (this.file_type == 2) {
      //   missionid = this.items.otc_missionid
      // }
      this.$ajax({
        method: "post",
        // url: "http://202.130.113.149:3785/admin/getQmisUserMsgWithUsername",
        url: this.$api.getIOQAuditInterface,
        data: {
          username: this.items.username,
          // missionid: missionid,
        },
      }).then((res) => {
        if (res.data.qmiscode == 1000) {
          this.dataAll = res.data 
          this.emailData =  res.data.email.split('; ')
          console.log(this.emailData.length);
         
        } else {
          App.oTool.warningT(res.data.qmismsg);
        }
      });
    },

    

  },
};
</script>

<style lang="scss">
.red_cla .ant-input{
  border-color: red;
}
.emailCla{
  display: inline-block;
  width: 225px;height: 100%;
  overflow: hidden;
  float: right;
  position: relative;
  left: 11%;
  text-overflow: ellipsis;
  // white-space: nowrap;
  // white-space:pre-line;
}
.btnOn{
  margin-right: 15%;
  background: #ed4849;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
}
.btnOK{
  background: #0c8b97;
  border: none;
  border-radius: 4px;
  color: #ffffff;
  padding: 10px 50px;
}
.myStyle{
  border-bottom: none !important;
}
.show-more{
  text-align: center;
}
.score-img {
  width: 16px;
  transition: all 0.3s;
}
.rotate-img {
  transform: rotate(180deg);
}
.content-top1{
  width: 100%;
  height: 60px;
  background:#ffffff; 
  color: #000000;
  line-height: 60px;
  display: flex;
  padding: 0 20px;

}
.phoneSty .ant-select-arrow {
  right: 6px !important;
}
.phoneSty .ant-input-affix-wrapper .ant-input:not(:first-child) {
  padding-left: 35%;
}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix {
  left: 2px !important;
  top: 18px;

}
.phoneSty .ant-input-affix-wrapper .ant-input-prefix :not(.anticon),
.ant-input-affix-wrapper .ant-input-suffix :not(.anticon) {
  line-height: 25.5px !important;
}
.phoneSty .ant-select-selection {
  border: 0 !important;
  height: 25px;
}
.phoneSty .ant-select-focused .ant-select-selection,
.ant-select-selection:active,
.ant-select-selection:focus {
  border: 0 !important;
  box-shadow: none !important;
}


.address .ant-form-item-label {
  width: 15% !important;
}
.address .ant-form-item-control-wrapper {
  width: 85% !important;
}
.content {
  padding-bottom: 1rem;
  border-radius: 0 0 10px 10px;
  padding: 1rem;
  background-color: #fff;
  width: 38rem;
  margin: 0 auto;
  margin-bottom: 1rem;
  min-height: 50px;
}
#warp_sim12 .ant-modal-header,
#warp_sim12 .ant-modal-body {
  background-color: #e5e5e5 !important;
  padding: 1rem;
  padding-top: 0.7rem;
}

.mark-file {
  position: absolute;
  top: 0;
  left: 0;

  div {
    width: 6rem;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    display: inline-block;
  }
}

#warp_sim12 {
  .ant-radio-wrapper {
    display: flex;
    align-items: center;
  }
  .ant-form-explain {
    display: none;
  }

  .ant-modal {
    top: 8%;
  }

  .ant-col-12 {
    text-align: right;
  }
  .myleft {
    text-align: left;
  }
  .ant-form-item-label {
    width: 30%;
  }

  .ant-form-item,
  .ant-form-item-control {
    width: 100%;

    .ant-calendar-picker {
      width: 100%;
    }
  }

  .ant-radio-group-default {
    width: 100%;
    margin-top: 0.3rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    span {
      font-size: 0.8rem;
    }
  }

  .ant-form-item-control-wrapper {
    width: 70%;

    .ant-form-item-control {
      width: 100%;
    }
  }

  #lastname {
    text-align: right;

    .ant-form-item-label {
      width: 10%;
    }

    .ant-form-item-control-wrapper {
      width: 86%;
    }
  }

  .ant-form-inline .ant-form-item {
    margin-right: 0;
  }

  .ant-modal-content {
    border-radius: 10px;
  }

  .ant-form-item {
    margin-bottom: 1rem;
  }

  .ant-form-item label {
    font-size: 0.8rem !important;
  }

  .ant-input {
    font-size: 0.8rem !important;
  }

  .ant-select-selection-selected-value {
    font-size: 0.8rem !important;
  }

  .ant-form-item-children {
    font-size: 0.8rem !important;
  }

  .ant-modal-body {
    padding: 0;
    padding-top: 2.5rem;
  }

  .btn1 {
    cursor: pointer;
    width: 8rem;
    height: 2rem;
    font-size: 0.8rem;
    color: #fff;
    border: 0;
    border-radius: 5px;
    margin: 0 3rem;
  }

  .btnx {
    background-color: #0c8b97;
  }

  .btn2 {
    background-color: #ed4849;
  }

  .mydivs {
    max-height: 7rem;
    overflow-y: auto;
    // margin-bottom: 1rem;
    padding: 1rem;
    margin-left: 4%;
    width: 96%;
    background-color: #f5f5f5;
    margin-bottom: 1rem;

    .c {
      font-size: 0.8rem;
    }

    .f {
      // text-align: right;
      display: flex;
      justify-content: space-between;
    }

    .t {
      margin: 0.5rem 0;
      border-bottom: 1px solid #d9d9d9;
    }
  }
  .denglu .ant-select{
    width: 9rem;
  }
}
</style>
